<template>
    <section class="hero login is-fullheight is-primary is-bold animated">
        <div class="hero-body">
            <div class="container box app-connexion">
                <div class="p-md m-b-md">
                    <form @submit.prevent="newPassword" v-if="!sentEmail" key="send-email">
                        <b-field label="Email" class="has-text-left">
                            <b-input
                                    type="email"
                                    v-model="email"
                                    required>
                            </b-input>
                        </b-field>

                        <b-field label="Nouveau mot de passe" class="has-text-left">
                            <b-input
                                    type="password"
                                    v-model="password"
                                    minlength="6"
                                    password-reveal
                                    required>
                            </b-input>
                        </b-field>

                        <b-field label="Répétez le mot de passe" class="has-text-left">
                            <b-input
                                    type="password"
                                    v-model="password_confirmation"
                                    minlength="6"
                                    password-reveal
                                    required>
                            </b-input>
                        </b-field>

                        <p class="has-text-danger" v-if="errorForm">{{ errorForm }}</p>


                        <div class="container-fluid" key="button">
                            <button :class="'button is-primary is-fullwidth ' + isLoading">Envoyer</button>
                        </div>

                    </form>

                    <b-notification type="is-primary" key="sent-email" :closable="false" v-else>
                        <div><i>Votre mot de passe à bien été changé</i></div>
                    </b-notification>

                    <br>
                    <div v-if="error" class="notification is-warning animated fadeIn">{{error}}</div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {
                isLoading: '',
                email: '',
                password: '',
                password_confirmation: '',
                error: '',
                errorForm: '',
                sentEmail: false
            }
        },
        computed: {
            ...mapState({
                auth: 'auth'
            }),
            ...mapGetters({
                userRoles: 'auth/getRoles',
                account: 'auth/getAccount'
            }),
            application () {
                if (this.account.candidates && this.account.candidates.length > 0) {
                    return this.account.candidates[ 0 ].applications
                }else{
                    return null
                }

            }
        },
        methods: {
            ...mapActions({
                reset: 'auth/resetPassword'
            }),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            showRegister: function () {
                this.$emit('register')
            },
            showLogin: function () {
                this.$emit('login')
            },
            newPassword: function () {
                this.toggleLoading()
                const credentials = {
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    token: this.$route.params.token
                }
                if (this.password !== this.password_confirmation) {
                    this.errorForm = 'Les mots de passes doivent être identiques'
                    return
                }
                this.reset(credentials).then((result) => {

                    if (this.auth.status === 200) {
                        this.toggleLoading()
                        if (this.isCandidate()) {
                            if (this.application && this.application.school_slug) {

                                if (this.$route.meta.schoolType === 'boardingschool') {
                                    this.$router.push({
                                        name: 'school-connection',
                                        params: { school: this.application.school_slug }
                                    })
                                }

                                if (this.$route.meta.schoolType === 'highschool') {
                                    this.$router.push({
                                        name: 'highschool-connection',
                                        params: { school: this.application.school_slug }
                                    })
                                }

                                if (this.$route.meta.schoolType === 'eschool') {
                                    this.$router.push({
                                        name: 'eschool-connection',
                                        params: { school: this.application.school_slug }
                                    })
                                }

                            } else {

                                if (this.$route.meta.schoolType === 'boardingschool') {
                                    this.$router.push({ path: '/admissionsco' })
                                }

                                if (this.$route.meta.schoolType === 'highschool') {
                                    this.$router.push({ path: '/admissionsup' })
                                }

                                if (this.$route.meta.schoolType === 'eschool') {
                                    this.$router.push({ path: '/admissioneschool' })
                                }
                            }

                        } else {
                            this.$router.push({ name: 'admin-connection' })
                        }

                    } else {
                        this.toggleLoading()
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                    }
                }).catch(() => {
                    this.toggleLoading()
                    this.error = 'Une erreur s\'est produite veuillez réessayer plus tard'
                })
            },
            isCandidate () {
                return this.userRoles && this.userRoles.indexOf('candidate') > -1
            },

        },

        mounted () {
            this.email = this.$route.query.email
        }
    }
</script>

<style scoped>

    .button {
        width: 100%;
    }

    .connexion-switch {
        height: 4rem;
    }

</style>
